/**
 * HasNotBoughtConditionType - Condition qui vérifie si un achat n'a pas été fait
 * Identique à Java HasNotBoughtCondition
 * 
 * Note: Dans le backend Java, cette condition vérifie via AccountingService si l'utilisateur
 * a acheté l'aventure. En mobile, on vérifie simplement si l'attribut d'achat n'est pas présent
 * dans les adventureExtraFields (comme HasBoughtCondition mais inversé).
 */

import {ConditionType} from '../types/ConditionType';
import {GameState} from '../../../models/GameState';

export class HasNotBoughtConditionType implements ConditionType {
  typeName = 'COND_HAS_NOT_BOUGHT';
  messageKey = 'laventurier.condition.has.not.bought.name';
  descriptionKey = 'laventurier.condition.has.not.bought.desc';
  errorKey = 'laventurier.condition.has.not.bought.error';
  hasValue = false;
  hasAttribute = true;

  evaluate(gameState: GameState, condition: any): boolean {
    const attributeId = condition.attribute || condition.attributeId;
    if (!attributeId) {
      console.log('[HasNotBoughtConditionType] FALSE: no attribute specified');
      return false;
    }

    const typeName = attributeId.toString();
    // Vérifier si l'attribut d'achat n'est PAS présent dans adventureExtraFields
    const hasBought = gameState.data.adventureExtraFields.some((e) => e.type === typeName);
    const result = !hasBought;
    console.log(`[HasNotBoughtConditionType] ${result ? 'TRUE' : 'FALSE'}: ${typeName} ${hasBought ? 'found' : 'not found'} in adventureExtraFields`);
    return result;
  }
}
